import { render, staticRenderFns } from "./CheckboxWithLabel.vue?vue&type=template&id=21b2bd42&"
import script from "./CheckboxWithLabel.vue?vue&type=script&lang=js&"
export * from "./CheckboxWithLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports